import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { StampCertificateNewCrumbs } from 'civil-status/constants/breadcrumb';
import FormStampCertificate, {
  StampCertificateForm,
} from 'civil-status/components/stamp-certificate/form';
import { useNavigate } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const StampCertificateNewPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const insertStampCertificate = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/testo-stampa-certificazione/crea-testo-stampa-certificazione`,
    {
      options: {
        method: 'POST',
      },
    }
  );

  const handleSubmit = useCallback(
    (values: StampCertificateForm) => {
      (
        insertStampCertificate({
          data: {
            key: {
              codiceTesto: values.code,
            },
            tipoElemento: values.printElement,
            testoStampa: values.text,
            tipoStampa: values.type,
            tipoAtto: values.typeAct,
            codiceModificatore: values.editor,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/timbri');
      });
    },
    [insertStampCertificate, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={StampCertificateNewCrumbs} />
      <FormStampCertificate
        title={'Nuovo Timbro Certificato'}
        onOk={handleSubmit}
        onCancel={() => {
          navigate('/stato-civile/timbri');
        }}
      ></FormStampCertificate>
    </Fragment>
  );
};

StampCertificateNewPage.displayName = 'Stamp Certificate New page component';

export default StampCertificateNewPage;
